export enum ElementType {
  //Elements
  unknown = 0,
  container = 1,
  button = 2,
  input = 3,
  form = 4,
  text = 5,
  chart = 6,
  table = 7,
  section = 8,
  page = 9,
  menu = 10,
  list = 11,
  tabs = 12,
  timeline = 13,
  widgetNavigation = 14,
  confirm = 15,
  modal = 16,
  file = 17,
  wizard = 18,
  pagination = 19,
  signature = 20,
  numpad = 21,
  scanner = 22,
  logout = 23,
  settings = 24,
  footer = 25,
  refresh = 26,
  condition = 27,
  geolocation = 28,
  //Actions
}
